export const SESSION_PREFIX = 'rxnxt:tab:v1:';
export const sessionKey = (scope, resource) => `${SESSION_PREFIX}${scope}:${resource}`;

export const readSession = (key, fallback) => {
  if (!key) return fallback;
  try {
    const stored = JSON.parse(sessionStorage.getItem(key));
    return stored?.version === 1 ? stored.value : fallback;
  } catch {
    return fallback;
  }
};

export const writeSession = (key, value) => {
  if (!key) return true;
  try {
    sessionStorage.setItem(key, JSON.stringify({ version: 1, value }));
    return true;
  } catch {
    // Private mode and a full storage quota must not stop the form from working.
    return false;
  }
};

export const removeSession = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch {}
};

export const clearSessionScope = (scope) => {
  advanceSessionRevision();
  try {
    const prefix = scope ? sessionKey(scope, '') : SESSION_PREFIX;
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(prefix))
      .forEach(removeSession);
  } catch {}
};

export const readAuthSession = (key) => {
  try {
    const data = JSON.parse(localStorage.getItem(key));
    if (data?.user?._id && data.token && new Date(data.expiration) > new Date()) return data;
    if (data?.user?._id) clearSessionScope(`${key.replace('Data', '')}:${data.user._id}`);
  } catch {}
  return null;
};

let sessionRevision = 0;
export const getSessionRevision = () => sessionRevision;
export const advanceSessionRevision = () => {
  sessionRevision += 1;
};
